import {useContext, useEffect, useRef, useState} from 'react';
import Nav from 'react-bootstrap/Nav';
import {faCircleUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import AuthContext from "context/AuthContext";
import ConditionalRender from "components/ConditionalRender";



const NavUser = () => {
    const {user, logoutUser} = useContext(AuthContext)
    const [t] = useTranslation("common")
    const currentDomain = window.location.hostname;
    const isOrionaiot = currentDomain.toLowerCase().includes("orionaiot");
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const navUserRef = useRef(null);

    const style = {
        fontSize: "0.8rem",
        color: "white",
        textWrap: "nowrap"
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (navUserRef.current && !navUserRef.current.contains(event.target)) {
            setVisible(false);
        }
    };

    const viewCount = ()=>{
        setVisible(false);
        navigate('/profile/');
    }

    return (
        <div ref={navUserRef}>
            <Nav className="ms-auto">
                <button onClick={() => setVisible(!visible)}
                        style={{background: "none", border: "none", textAlign: "left"}} id="nav-top-drop-user"
                        className="dropdown-user p-0">
                    <div className="d-flex justify-content-center justify-content-center me-4">
                        <div className="d-inline-block pe-1" style={style}>
                            {user.email}<br/>
                            {user.first_name + " " + user.last_name}
                        </div>
                        <div className="container">
                            {user.avatar === "" ?
                                <FontAwesomeIcon icon={faCircleUser} className="fa-2x" color="white"/>
                                : <div>
                                    <img className="rounded-circle" alt="avatar-user" src={"/media/" + user.avatar}
                                         style={{height: "90%", position: "absolute", right: "10px", top: "0"}}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </button>
                <ConditionalRender condition={visible}>
                    <div className="nav-top-drop-containers">
                        <div className="d-flex nav-top-drop-header">
                            <p className="mt-3">{isOrionaiot ? "OrionAiot" : "Sol-X"}</p>
                            <button onClick={logoutUser}>
                                {t("user.logout")}
                            </button>
                        </div>
                        <div className="nav-top-drop-body">
                            <div>
                                {user.avatar === "" ?
                                    <FontAwesomeIcon icon={faCircleUser} className="fa-7x" color="grey"/>
                                    : <img src={"/media/" + user.avatar}
                                           style={{width: "100%"}} alt="avatar"/>
                                }
                            </div>
                            <div className="m-2">
                                <div className="container h5">{user.first_name + " " + user.last_name}</div>
                                <div className="container">{user.email}</div>
                                <div className="container">
                                    <button type="button" className="btn btn-sm btn-link text-primary" onClick={viewCount}>Ver Cuenta</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </ConditionalRender>
            </Nav>
        </div>
    )
}
export default NavUser